import $ from "jquery";

export const cardFilter = () => {
  /** Search input functionality */
  $(".layout.cards.has-filter .search-input").on("keyup", (e) => {
    const search = $(e.currentTarget).val().toLowerCase();
    const $section = $(e.currentTarget).parents(".layout");
    const $cards = $section.find(".card");

    // Reset the select
    $section.find(".card-filter-select").val("");

    // Show all cards if search is empty
    if (!search) {
      $cards.closest(".card-column").show();
      return;
    }

    $cards.each((index, card) => {
      const $card = $(card);
      const title = $card.find(".card-title").text().toLowerCase();
      const description = $card.find(".card-text").text().toLowerCase();

      if (title.includes(search) || description.includes(search)) {
        $card.closest(".card-column").show();
      } else {
        $card.closest(".card-column").hide();
      }
    });
  });

  /** Category select functionality */
  $(".layout.cards.has-filter .card-filter-select").on("change", (e) => {
    const category = $(e.currentTarget).val();
    const $section = $(e.currentTarget).parents(".layout");
    const $cards = $section.find(".card");

    // Empty the search
    $section.find(".search-input").val("");

    // Show all cards if category is default
    if (!category) {
      $cards.closest(".card-column").show();
      return;
    }

    $cards.each((index, card) => {
      const $card = $(card);
      const categories = $card.attr("data-categories").split(",");

      if (categories.includes(category)) {
        $card.closest(".card-column").show();
      } else {
        $card.closest(".card-column").hide();
      }
    });
  });
};
